export const INVALID_PAYMENT_GATEWAY = 'service.order.invalid.payment.gateway';
export const INVALID_CREDIT_CARD = 'service.order.invalid.payment.details';
export const TNS_ERROR_MESSAGE = 'TNS credit cards are not supported';

// We don't have an exhaustive list of error keys so the key type is currently a string.
export const mightRequirePaymentMethodToBeRefilled = (errorKey: string) =>
  [INVALID_PAYMENT_GATEWAY, INVALID_CREDIT_CARD].includes(errorKey);
